import cn from 'clsx'

import React from 'react'
import styles from './index.module.css'

export type Props = {
  children?: React.ReactNode
  className?: string
}

/**
 * A component that displays error text with consistent styling
 * @param children - The error text content to display
 * @param className - Additional CSS classes to apply to the error text
 * @returns A div element with error text styling and a non-breaking space
 */
const ErrorText = (props: Props): React.ReactElement<'div'> => {
  const { children, className } = props
  const errorClassName = cn(styles.errorText, className)
  return <div className={errorClassName}>{children}&nbsp;</div>
}

export default ErrorText
